import { Box } from '@material-ui/core';
import { experimentalStyled as styled } from '@material-ui/core/styles';

export const LayoutContainer = styled(Box)`
  display: flex;
  background: ${({ theme: { palette } }) => palette.common.white};
  user-select: none;
`;
